export const useFileUploadContent = () => ({
  dropzoneDescripton: 'verification-trademark-dropzone-desc',
  formatErrorMessage: 'error-upload-correct-format',
  sizeErrorMessage: 'error-upload-correct-size',
  moreThanOneFileErrorMessage: 'more-than-one-file-error-message',
  tooManyFilesErrorMessage: 'too-many-files-error-message',
  errorUploadingFile: 'error-uploading-file',
  apiErrorMessage: 'api-error-description',
  loadingTitle: 'loading-title',
  openFileTitle: 'open-file-title',
  downloadTitle: 'download-text',
  downloadingFileTitle: 'downloading-file-title',
  downloadingFileSuccess: 'downloading-file-success',
  downloadingFileError: 'downloading-file-error',
  removeButton: 'button-remove',
  removingFileTitle: 'removing-file-title',
  removingFileSuccess: 'removing-file-success',
  removingFileError: 'removing-file-error',
  addAttachmentsTitle: 'add-attachments-title',
  maxFilesAndSizeNote: 'max-files-and-size-title',
  maxFilesReachedNote: 'note-reached-max-files-for-uploading',
  uploadFileTitle: 'upload-file-title',
  dragAndDropTitle: 'drag-and-drop-title',
  browseTitle: 'browse-title',
  uploadedTitle: 'uploaded-title',
  uploadingTitle: 'uploading-title',
  openInNewTabTitle: 'open-new-tab',
})
